/**
 * Internal route constants for the landing-page app.
 *
 * The actual routing is done by the React app (apps/frontend) — see
 * apps/frontend/src/config/route-constant.ts. We duplicate the subset of
 * routes that the landing-page links to. If a route here doesn't match
 * what apps/frontend exposes, the link silently 404s (the original
 * /register vs /signup bug).
 *
 * Use these constants for every internal href. The
 * `no-restricted-syntax` ESLint rule (see eslint.config.mjs) bans
 * string-literal hrefs starting with `/[a-zA-Z]` to enforce this.
 */
export const ROUTES = {
  home: "/",
  login: "/login",
  signup: "/signup",
  campaigns: "/campaigns",
  settings: "/settings",
  api: "/api",
  pricing: "/pricing",
  affiliateProgram: "/affiliate-program",
  // Hash anchors on the landing page (rule doesn't flag these — `/#x` doesn't match `/[a-zA-Z]`)
  hero: "/#hero",
  pricingAnchor: "#pricing",
  homePricing: "/#pricing",
  pricingSection: "/pricing#pricing",
  howItWorksDemo: "/#how-it-works-demo",
  features: "/#features",
  faq: "/#faq",
} as const;
